<template>
  <li class="anz-mr-xs anz-tabs-carousel__item" :id="id">
    <a-button
      className="anz-btn anz-b-none anz-flex-inline anz-align-items-center anz-text-nowrap anz-text-transform-none anz-px-s"
      @click="onclick"
      :class="{ 'anz-btn-primary': active }"
    >
      <template #title>
        {{ title }}
        <span class="anz-btn-badge anz-ml-xs">{{ count }} </span>
      </template>
    </a-button>
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'

export default defineComponent({
  name: 'ProfileMenuItem',
  components: { AButton },
  emits: ['click'],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onclick(event: any) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    },
  },
})
</script>
